export const blockIconsActivitiesWavesNew = (
	<span className='material-symbols-outlined'>waves</span>
);
